import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Heart } from "@faire/web--source/slate/icons/foundation/Heart";
import classNames from "classnames";
import * as React from "react";
import styled from "styled-components";
export var FavoriteButton = function(param) {
    var light = param.light, onClick = param.onClick, size = param.size, favorited = param.favorited, ariaLabel = param.ariaLabel;
    var Icon = light ? LightHeartIcon : DarkHeartIcon;
    return /*#__PURE__*/ _jsx(Button, {
        onClick: onClick,
        $size: size,
        $favorited: favorited,
        "aria-label": ariaLabel,
        children: /*#__PURE__*/ _jsx(Icon, {
            $favorited: favorited,
            className: classNames(light ? "light-heart-icon" : "dark-heart-icon")
        })
    });
};
var DarkHeartIcon = styled(Heart).withConfig({
    componentId: "sc-f1a3bd7d-0"
})([
    "stroke-width:1px;path{stroke:",
    ";fill:",
    ";fill-opacity:",
    ";}"
], Core.icon.inverse, function(props) {
    return props.$favorited ? Core.icon.critical : Core.icon.default;
}, function(props) {
    return props.$favorited ? 1 : 0.5;
});
var LightHeartIcon = styled(Heart).withConfig({
    componentId: "sc-f1a3bd7d-1"
})([
    "stroke-width:1px;path{stroke:",
    ";fill:",
    ";}"
], function(props) {
    return props.$favorited ? Core.icon.critical : Core.icon.default;
}, function(props) {
    return props.$favorited ? Core.icon.critical : "transparent";
});
var Button = styled.button.withConfig({
    componentId: "sc-f1a3bd7d-2"
})([
    "display:flex;justify-content:center;align-items:center;font-size:",
    ";margin:4px;transition:all 50ms ease-in;&:active{transform:scale(1.2);}&:focus-visible{outline:auto;outline:2px solid -webkit-focus-ring-color;outline-offset:2px;}&:hover{.dark-heart-icon{path{fill-opacity:",
    ";}}.light-heart-icon{path{stroke:",
    ";}}}"
], function(props) {
    var _props_$size;
    return (_props_$size = props.$size) !== null && _props_$size !== void 0 ? _props_$size : "24px";
}, function(props) {
    return props.$favorited ? 1 : 0.8;
}, Core.icon.critical);
